import { FilterDateDashboard } from "../../../../components/Dashboard/ViewDatas/FilterDate";
import { ReactComponent as BagFood } from "../../../../assets/svg/icons/bagFood.svg";
import { DateModal } from "../../../../components/Modal/DateFilter";
import { useFilter } from "../../../../hooks/useFilter";
import Constants from "../../../../constants/Index";
import axios from "../../../../services/axios"
import { useEffect, useState } from "react";
import { IOptionProps } from "../../../../@types/reactSelect/IOption";
import { Dropdown } from "../../../../components/EditOnboarding/components/Select";
import { useForm } from "react-hook-form";
import { format } from "date-fns";
import { daysBetweenDates } from "../../../../utils/date/daysBetweenDays";

export default function DashboardSupplementationProductConsumption() {
  const {
    farmFilter,
    areasIdsFilter,
    rangeDays,
    onBoardingDate,
    setRangeDays,
    setHideMicroAreaFilter,
    setHideBatchFilter,
    setDashboard,
    setSideBarOptionSelected,
    setSelectRangeDate
  } = useFilter();

  const {
    handleSubmit,
    control,
    watch,
    setValue
  } = useForm();

  const [optionsClassification, setOptionsClassification] = useState<IOptionProps[]>([]);
  const [optionsProduct, setOptionsProduct] = useState<IOptionProps[]>([]);
  const [consumptionByMonth, setConsumptionByMonth] = useState<IConsumptionByMonth[]>();
  const selectedClassification = watch("classification")
  const selectedProducts = watch("products")
  const [allAreas, setAllAreas] = useState<IOptionProps[]>([]);
  const [mapMounths] = useState(new Map());

  useEffect(() => {
    const now = new Date();
    const lastYear = new Date(now.getFullYear() - 1, now.getMonth(), now.getDay());

    setRangeDays({
      from: daysBetweenDates(now, onBoardingDate || lastYear) > 365 ? lastYear : onBoardingDate,
      to: now
    })
  }, [allAreas]);

  useEffect(() => {
    setHideMicroAreaFilter(true)
    setHideBatchFilter(true)
    setSideBarOptionSelected("DASHBOARD")
    setDashboard("SUPPLEMENTATION")
    setSelectRangeDate(2)
    document.title = Constants.TITLE_DASHBOARD;
  }, []);

  useEffect(() => {
    if (farmFilter && areasIdsFilter.length == 0) {
      axios.get("/areas", {
        params: {
          farm_id: farmFilter.id
        }
      }).then((response) => {
        const areas = response.data.map((item: IArea) => ({
          label: item.name,
          value: item.id
        }));
        setAllAreas(areas);
      })
    }
  }, [, farmFilter]);

  useEffect(() => {
    if (farmFilter?.id && (rangeDays || areasIdsFilter.length > 0 || allAreas.length > 0) && selectedClassification && selectedProducts) {
      let startDate = format(rangeDays?.from ? new Date(rangeDays?.from) : new Date(), 'yyyy-MM-dd HH:mm:ss')
      let endDate = format(rangeDays?.to ? new Date(rangeDays?.to) : new Date(), 'yyyy-MM-dd HH:mm:ss')

      const params = {
        farmId: farmFilter.id,
        areaIds: areasIdsFilter.length > 0 ? areasIdsFilter.map((item) => item.value) : allAreas.map((item) => item.value),
        classificationId: selectedClassification.value,
        supplementId: selectedProducts.map((item: any) => item.value),
        startDate: startDate,
        endDate: endDate
      }

      axios.get("/supplement/consumption-by-month", {
        params,
        paramsSerializer: params => {
          return new URLSearchParams(params).toString();
        }
      }).then((response) => {
        const resposeConsumption: IConsumptionByMonth[] = response.data;
        mapMounths.clear();
        resposeConsumption.map((area) => area.months.map((month) => {
          const existingMonths = mapMounths.get(month.year_month) || [];
          mapMounths.set(month.year_month, [...existingMonths, month.total_consumption]);
        }));

        setConsumptionByMonth(response.data);
      })
    }
  }, [rangeDays, areasIdsFilter, selectedClassification, selectedProducts, allAreas]);

  useEffect(() => {
    axios.get("/products/supplement/classification")
      .then(({ data }) => {
        setOptionsClassification(
          data.map((el: any) => (
            {
              label: el.name,
              value: el.id,
            }
          ))
        )
      })

    axios.get("/products/all")
      .then(({ data }) => {
        setOptionsProduct(
          data.map((el: any) => (
            {
              label: el.trade_name,
              value: el.id,
              info: el.classification
            }
          ))
        )
      })
  }, []);

  return (
    <div className="cattleMap_background" style={{ overflowY: "auto" }}>
      <form onSubmit={() => handleSubmit(() => { })}>

        <DateModal />

        <div className="cattleMap_page">
          <div className="cattleMap_header">
            <BagFood height={72} />
            <div style={{
              display: "flex",
              flexDirection: "column",
            }}>
              <h2 className="cattleMap_title">
                Suplementação
              </h2>
              <h3 className="cattleMap_subtitle">
                Consumo por mês
              </h3>
            </div>
          </div>

          <div>
            <FilterDateDashboard />

            <div style={{ width: 400 }}>
              <Dropdown
                control={control}
                label={"CLASSIFICAÇÂO"}
                name={"classification"}
                closeMenuOnSelect={true}
                placeholderText={"Selecione..."}
                options={optionsClassification.filter((classification) => optionsProduct.map(el => el.info).includes(classification.label))}
                getSelectedData={() => {
                  setValue("products", null)
                }}
              />

              <Dropdown
                control={control}
                label={"PRODUTO"}
                name={"products"}
                closeMenuOnSelect={true}
                placeholderText={"Selecione..."}
                noOptionsMessage={() => "Nenhum produto disponível"}
                options={selectedClassification ? optionsProduct.filter(product => product.info == selectedClassification.label) : []}
                isMulti
              />
            </div>
          </div>
        </div>

        <br />

        {consumptionByMonth ?
          <div className="tableDashboard" id={"analise_geral"}>
            <h2>Consumo por mês</h2>
            <table>
              <thead style={{ color: "#fff" }}>
                <th scope="col" rowSpan={2} style={{ background: "#324440", width: "280px", textAlign: "left" }}>
                  Retiro
                </th>
                {Array.from(mapMounths.keys()).map((month, index) => (
                  <th
                    key={index}
                    style={{
                      background: index % 2 === 0 ? "#808080" : "#324440",
                      width: index === 13 ? "210px" : "150px"
                    }}
                  >
                    {month}
                  </th>
                ))}
                <th style={{
                  background: "#808080",
                  width: "150px"
                }}>
                  Média Anual
                </th>
                <th scope="col" style={{
                  background: "#324440",
                  width: "210px"
                }}>
                  Frequência de Reposição
                  <br />
                  (Média de dias)
                </th>

              </thead>
              {consumptionByMonth?.map((area, index) =>
                <tbody>
                  {
                    <tr className={index % 2 === 0 ? " bg_white" : "bg_gray"}>
                      <th scope="row">{area.area_initials}</th>
                      {area.months.map((month) => <td>{month.total_consumption}</td>)}
                      <td>{area.months.length > 0 ? (Number(area.months.reduce((acc, item) => acc + item.total_consumption, 0) / 12).toFixed(2)) : 0}</td>
                      <td>{area.replacement_frequency}</td>
                    </tr>
                  }
                </tbody>
              )}
              <tfoot
                style={{
                  background: "#324440",
                  color: "#fff"
                }}
              >
                <th style={{
                  textAlign: "left"
                }}>Somatória da Fazenda</th>
                {Array.from(mapMounths.values()).map((month: number[], index) =>
                  <th key={index}>
                    {month.reduce((acc, item) => acc + item, 0)}
                  </th>
                )}
                <th>
                  {Number(Array.from(mapMounths.values()).flat().reduce((acc, item) => acc + item, 0) / 12).toFixed(2)}
                </th>
                <th />
              </tfoot>
            </table>
          </div>
          : <></>
        }

      </form >
    </div >
  );
}
